/**
 * Unit of measure for the Maturity Month Year Increment
 * tag: 1302
 * @readonly
 * @enum {number} (int)
 */
export enum MaturityMonthYearIncrementUnits {
  /** Months */
  Months = 0,
  /** Days */
  Days = 1,
  /** Weeks */
  Weeks = 2,
  /** Years */
  Years = 3,
}
